var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 5.92486 18.5751 1 12.5 1C6.42486 1 1.5 5.92486 1.5 12C1.5 17.4903 5.52252 22.0412 10.7812 22.8664V15.1797H7.98828V12H10.7812V9.57656C10.7812 6.81969 12.4235 5.29688 14.9361 5.29688C16.1392 5.29688 17.3984 5.51172 17.3984 5.51172V8.21875H16.0114C14.645 8.21875 14.2188 9.06674 14.2188 9.9375V12H17.2695L16.7818 15.1797H14.2188V22.8664C19.4775 22.0412 23.5 17.4903 23.5 12Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5488d8357810c8a0afab0fdc6b19e771.svg";
export { ForwardRef as ReactComponent };